import { ProductInfoProduct, UpsellProduct } from '../../types'

export type ShowProductModal = {
  product: ProductInfoProduct
  upsellProduct?: UpsellProduct
  triggerElementRef?: React.RefObject<HTMLAnchorElement | null>
  onTrackingInfo?: (event: { product: ProductInfoProduct }) => {
    label: string
    listName: string
    itemIndex: number
  }
}

export type Dispatcher = {
  show: (params: ShowProductModal) => void
  showProduct: (product: ProductInfoProduct) => void
  close: () => void
}

type ProductModalEvent<T = string, TP = unknown> = {
  type: T
  payload?: TP
}

export type ProductModalClosed = Omit<
  ProductModalEvent<'PRODUCT_MODAL_CLOSED'>,
  'payload'
>

export type ProductModalShown = ProductModalEvent<
  'PRODUCT_MODAL_SHOWN',
  ProductInfoProduct
>

export type ProductModalState = {
  product?: ProductInfoProduct
  upsellProduct?: UpsellProduct
  triggerElementRef?: React.RefObject<HTMLAnchorElement | null>
  isOpen: boolean
  onTrackingInfo?: (event: { product: ProductInfoProduct }) => {
    label: string
    listName: string
    itemIndex: number
  }
}

export const EMPTY_STATE: ProductModalState = {
  isOpen: false,
}
